import React, { useState } from "react";

export const GaHeader: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const laws = [
        { id: "law-20-2020", text: "Lei 20/2020 (sistema viário)" },
        { id: "law-22-2020", text: "Lei 22/2020 (parcelamento do solo)" },
        { id: "law-23-2020", text: "Lei 23/2020 (código de posturas)" },
        { id: "law-24-2020", text: "Lei 24/2020 (perímetro urbano e rural)" },
        { id: "law-25-2020", text: "Lei 25/2020 (zoneamento)" },
        { id: "law-26-2020", text: "Lei 26/2020 (código de obras)" },
    ];

    return (
        <header>
            <div
                className={`bg-gray-900 text-white transition-all duration-300 ${
                    isOpen ? "block" : "hidden"
                }`}
            >
                <div className="container mx-auto p-6 flex flex-col md:flex-row md:justify-between">
                    <div className="md:w-2/3">
                        <h4 className="text-xl font-semibold">
                            Sobre a Guia Amarela
                        </h4>
                        <p className="text-gray-300 mt-2">
                            A consulta da Guia Amarela pode ser amplamente
                            utilizada para requerer informações sobre: uso e
                            parâmetros para a ocupação do solo, potencialidade
                            de construção, elaboração de projetos
                            arquitetônicos, cálculos de taxa de ocupação e
                            coeficientes de aproveitamento.
                        </p>
                        <p className="text-gray-300 mt-4 font-bold">
                            Leis em vigor a partir de 2021:
                        </p>
                        <ul className="list-disc list-inside text-gray-400 mt-2">
                            {laws.map((law) => (
                                <li key={law.id}>{law.text}</li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:w-1/3 mt-6 md:mt-0">
                        <h4 className="text-xl font-semibold">Contatos</h4>
                        <ul className="mt-2 text-white-400">
                            <li>
                                📍 Endereço: RUA PEDRO DRUSZCZ, Nº 111, (1º
                                Andar) - CENTRO - Araucária/PR
                            </li>
                            <li>📞 Telefone: (41) 3614-1443</li>
                            <li>📧 Email: du.smur@araucaria.pr.gov.br</li>
                            <li>⏰ Plantão Técnico (das 13:30 às 16:30)</li>
                        </ul>
                    </div>
                </div>
            </div>

            <nav className="bg-gray-900 shadow-md">
                <div className="container mx-auto flex justify-between items-center p-4">
                    <div className="flex items-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="text-white mr-3"
                        >
                            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                            <circle cx="12" cy="13" r="4" />
                        </svg>
                        <span className="text-white text-lg font-bold">
                            Guia Amarela - Araucária/PR
                        </span>
                    </div>

                    <button
                        type="button"
                        onClick={() => setIsOpen(!isOpen)}
                        className="text-white focus:outline-none"
                        aria-label="Toggle menu"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            className="w-6 h-6"
                        >
                            {isOpen ? (
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            ) : (
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M4 6h16M4 12h16m-7 6h7"
                                />
                            )}
                        </svg>
                    </button>
                </div>
            </nav>
        </header>
    );
};
